import { FC } from 'react';
import { Helmet } from 'react-helmet-async';

interface PageMetaProps {
    /** Used for <title> and inserted at the top of the meta description so
     *  link unfurls (Slack, Teams) read sensibly even on a noindex page. */
    title: string;
    description?: string;
}

/**
 * Per-page title + description. The realm-level `noindex, nofollow`
 * lives in index.html so search engines treat the whole UI as
 * non-indexable regardless of which page they crawl first.
 */
export const PageMeta: FC<PageMetaProps> = ({ title, description }) => (
    <Helmet>
        <title>{title}</title>
        {description ? <meta name="description" content={description} /> : null}
    </Helmet>
);
